import Home from "./home";
import Series from "./series";
import Sports from "./sports";
import Pricing from "./pricing";
import How from "./how";
import Device from "./device";
import Reviews from "./reviws";
import Faq from "./faq";

export default function All(){
    return(
        <>
            <Home/>
            <Series/>
            <Sports/>
            <Pricing/>
            <How/>
            <Device/>
            <Reviews/>
            <Faq/>
        </>
    )
}